import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base-service';
import { UserService } from './user.service';
import { UtilsService } from "./utils.service";
import { environment } from "../../environments/environment";
import { ECollection } from "../enums/ECollection";

@Injectable({ providedIn: 'root' })
export class AdvertisingMarqueeService extends BaseService {
    constructor(public override http: HttpClient,
                public override utilsService: UtilsService,
                public override userService: UserService) {
        super(http, userService, utilsService, `/schema/${environment.USER_PATH}/${environment.INS}/${environment.DB}/${ECollection.MP_ADVERTISING_MARQUEE}`);
    }

}
